import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MessageService } from '../message.service';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomInputEditor } from '../custom-inputEditor';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Subscription } from 'rxjs';
import * as d3 from 'd3';
import { AngularGridInstance, Formatters, GridOdataService, GridOption, FieldType, Column } from 'angular-slickgrid';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
    selector: 'app-dashboard-report-productivity',
    templateUrl: './dashboard-report-productivity.component.html',
    styleUrls: ['./dashboard-report-productivity.component.css']
})
export class DashboardReportProductivityComponent implements OnInit {

    respObject: any;
    private clientId: number;
    gridOptions: GridOption;
    columnDefinitions: Column[];
    private notifier: NotifierService;
    angularGrid: AngularGridInstance;
    gridObj: any;
    sLAComplainceObj = [];
    headerSLACompliance = [];
    reportTypeArray = [];
    reportFilterArray = [];
    teamArray = [];
    selectedReportType: number;
    selectedReportFilter: number;
    selectedTeam: number;
    dateRangeView: boolean;
    tillDateView: boolean;
    fromDate: string;
    toDate: string;
    tillDate: string;
    reportTypeTitle: string;
    reportFilterTitle: string;
    largegraph: boolean;
    viewTeam: boolean;

    dataLoaded: boolean;
    viewReport: boolean;
    viewReportSLA: boolean;

    //Report Data
    reportTableDat = [];
    reportTableRef = [];
    reportPieData = [];
    reportPieDataTeam = [];

    @ViewChild('barChart')
    private chartContainer: ElementRef;

    @ViewChild('barChartVolume')
    private barChartVolume: ElementRef;

    @ViewChild('pieChartVolume')
    private pieChartVolume: ElementRef;

    @ViewChild('reportBody')
    private reportBody: ElementRef;

    @ViewChild('ticketcontent')
    private ticketcontent;

    margin = { top: 20, right: 20, bottom: 30, left: 40 };

    gridObj1: any;

    columnData = [];

    dataset: any[];

    angularGrid1: AngularGridInstance;

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;

    }
    angularGridReady1(angularGrid: AngularGridInstance) {
        this.angularGrid1 = angularGrid;
        this.gridObj1 = angularGrid && angularGrid.slickGrid || {};
        this.columnData = this.gridObj1.getColumns();
    }


    ngOnInit() {

        // this.reportTypeArray = [{type:0, view:"Select Report Type"},
        //                         {type:1, view:"Overall"},
        //                         {type:2, view:"Team"}
        //                       ];

        // this.reportFilterArray = [{type:0, view:"Select Report Filter"},
        //                       {type:1, view:"Daily"},
        //                       {type:2, view:"Weekly"},
        //                       {type:3, view:"Monthly"},
        //                       {type:4, view:"Quarterly"},
        //                       {type:5, view:"Yearly"},
        //                       {type:6, view:"Till Date"},
        //                       {type:7, view:"From and to date"},
        //                     ];
        this.gridOptions1 = {
            enableAutoResize: true,
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableRowSelection: true,
        };
        this.dateRangeView = false;
        this.tillDateView = false;
        this.largegraph = true;
        this.viewTeam = false;
        this.dataLoaded = true;
        this.fromDate = '';
        this.toDate = '';
        this.tillDate = '';
        this.selectedReportFilter = 0;
        this.selectedReportType = 0;
        this.selectedTeam = 0;

        this.initSLAComplianceTableGrid();
        this.columnDefinitions = [];
        // this.getSLAComplianceTableReport();

        this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.clientId = this.respObject.details[0].clientId;
                //this.getSLAComplainceReport();
                this.getTeamByList();
                this.getFilters();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getFilters() {
        this._rest.getReportFilters(this.clientId, 'PRODUCTIVITY').subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {

                this.reportTypeArray = this.respObject.details[0].type;
                this.reportFilterArray = this.respObject.details[0].filter;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getTeamByList() {

        this._rest.getProductivityTeam(this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                //this.respObject.details.unshift({id: 0, name: 'Select Team'});
                this.teamArray = this.respObject.details;
                this.selectedTeam = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
                this.viewTeam = false;
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
            this.viewTeam = false;
        });
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        console.log('grid initiate');
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    initSLAComplianceTableGrid() {
        this.gridOptions = {
            enableAutoResize: true,
            enableCellNavigation: true,
            enableFiltering: true,
            editable: false,
            autoHeight: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableCheckboxSelector: false,
            enableRowSelection: true,
            enableHeaderMenu: true,
            enableGridMenu: true,
            headerRowHeight: 0,
        };
    }

    initSLAComplianceTable(tableDef) {
        // console.log("tableDef - ");
        // console.log(tableDef);
        const columnDefinitions = [];
        tableDef.forEach((column, i) => {
            if (column.field === 'totalAssignedTicketUnSolvedList') {
                columnDefinitions.unshift({
                    id: column.field, field: column.field, filterable: false, name: 'View Un-solved Tickets',
                    excludeFromHeaderMenu: true,
                    formatter: Formatters.infoIcon,
                    minWidth: 30,
                });
            } else {
                columnDefinitions.push({ id: column.field, name: column.name, field: column.field, sortable: false, filterable: false, minWidth: 50 });
            }

        });



        this.columnDefinitions = columnDefinitions;

    }

    onTeamChange(value: any) {
        this.selectedReportFilter = 0;
        this.fromDate = '';
        this.toDate = '';
        this.tillDate = '';
        this.tillDateView = false;
        this.dateRangeView = false;
    }

    onReportTypeChange(value: any) {
        this.selectedReportFilter = 0;
        this.selectedTeam = 0;
        this.fromDate = '';
        this.toDate = '';
        this.tillDate = '';
        this.tillDateView = false;
        this.dateRangeView = false;

        this.viewTeam = false;
        if (this.selectedReportType === 2 || this.selectedReportType.toString() === '2') {
            this.viewTeam = true;
        } else {
            this.viewTeam = false;
        }
    }

    onReportFilterChange(value: any) {
        this.fromDate = '';
        this.toDate = '';
        this.tillDate = '';
        this.tillDateView = false;
        this.dateRangeView = false;

        if (this.selectedReportFilter === 7 || this.selectedReportFilter.toString() === '7') {
            this.tillDateView = true;
            this.dateRangeView = false;
        } else if (this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === '6') {
            this.dateRangeView = true;
            this.tillDateView = false;
        } else {
            this.dateRangeView = false;
            this.tillDateView = false;
        }
    }

    generateSLAComplainceReport() {
        const fdate = this.messageService.ticketConverter(this.fromDate, 1);
        const tdate = this.messageService.ticketConverter(this.toDate, 1);
        const tilldate = this.messageService.ticketConverter(this.tillDate, 1);

        if (this.selectedReportType === 0) {
            this.notifier.notify('error', 'Please select a type');
            return;
        }

        if (this.selectedReportFilter === 0) {
            this.notifier.notify('error', 'Please select a filter');
            return;
        }

        if (this.selectedReportFilter === 7 || this.selectedReportFilter.toString() === '7') {
            if (this.tillDate === '') {
                this.notifier.notify('error', 'Please select date');
                return;
            }
        }

        if (this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === '6') {

            if (this.fromDate === '') {
                this.notifier.notify('error', 'Please select from date');
                return;
            }

            if (this.toDate === '') {
                this.notifier.notify('error', 'Please select to date');
                return;
            }
        }
        console.log('Selected Team');
        console.log(this.selectedTeam);
        if (this.selectedReportType === 2 || this.selectedReportType.toString() === '2') {
            if (this.selectedTeam === 0 || this.selectedTeam.toString() === '0') {
                this.notifier.notify('error', 'Please select a team');
                return;
            }
        }


        this.dataLoaded = false;
        this.viewReport = false;
        this.viewReportSLA = false;
        this.initSLAComplianceTable([]);
        this.sLAComplainceObj = [];

        this._rest.getProductivityReport(this.clientId, this.selectedReportType, this.selectedReportFilter, fdate, tdate, tilldate, this.selectedTeam).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataLoaded = true;
                this.viewReport = true;
                this.reportTypeTitle = this.reportTypeArray[this.selectedReportType].view;
                this.reportFilterTitle = this.reportFilterArray[this.selectedReportFilter].view;

                //console.log(this.respObject.details);
                this.initSLAComplianceTable(this.respObject.details[0].tableDef);
                this.sLAComplainceObj = this.respObject.details[0].tabledata;

                //this.createGroupChart(this.respObject.details[0].voldata);
                this.reportTableDat = this.respObject.details[0].tabledata;
                this.reportPieDataTeam = this.respObject.details[0].piedatateam;
                this.reportPieData = this.respObject.details[0].piedata;

                this.generateReportGraph();


            } else {
                this.dataLoaded = true;
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.dataLoaded = true;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    clearSlaChart() {
        const element = this.chartContainer.nativeElement;
        d3.select(element).select('svg').remove();
    }

    public modalRef: NgbModalRef;
    columnDefinitions1 = [];
    gridOptions1: GridOption;
    data = [];
    onCellClicked(e: any, args: any) {
        const metadata = this.angularGrid.gridService.getColumnFromEventArguments(args);

        const tktData = metadata.dataContext.totalAssignedTicketUnSolvedList;

        console.log(metadata);
        this.data = [];
        if (metadata.columnDef.id === "totalAssignedTicketUnSolvedList") {
            console.log(metadata);

            let tktId = '';
            for (let i = 0; i < tktData.length; i++) {
                tktId += tktData[i].id + ',';
                if (i === tktData.length - 1) {
                    tktId += tktData[i].id
                }
            }
            if (tktId.length > 0) {
                this.modalRef = this.modalService.open(this.ticketcontent, { size: 'lg' });
                this.modalRef.result.then((result) => {

                }, (reason) => {

                });
                this._rest.getoptimizedreportTicketDetailsReportByids(tktId).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success && this.respObject.details.length > 0) {

                        this.data = [];

                        const data1 = [];

                        let parsedata = this.respObject.details[0];

                        this.data = this.respObject.details;

                        let i = 0;

                        for (let i = 0; i < this.columnData.length; i++) {
                            data1.push(this.columnData[i]);
                        }

                        Object.keys(parsedata).forEach(function (key) {
                            i++;
                            let val = key.replace(/_/g, " ");
                            let key_new = val.charAt(0).toUpperCase() + val.slice(1);
                            console.log('Key : ' + key);

                            if (key_new === 'Ticket id ref') {
                                key_new = 'Ticket Id'
                            }

                            if (String(key) !== 'id' && String(key) !== 'ticket_id'
                                && String(key) !== 'client_id' && String(key) !== 'ticket_last_modified_dt'
                                && String(key) !== 'ticket_type') {
                                data1.push({
                                    id: key,
                                    name: key_new,
                                    field: key,
                                    sortable: true,
                                    filterable: true,
                                    minWidth: 100,
                                });
                            }

                        });
                        this.gridObj1.setColumns(data1);

                        this.gridObj1.getSelectionModel().setSelectedRanges([]);

                    }
                });
            } else {
                this.notifier.notify('error', 'No Tickets To Display');
            }
        }
    }

    capitalizeFirstLetter(str) {
        const capitalized = str.charAt(0).toUpperCase() + str.slice(1);

        return capitalized;
    }


    generateReportGraph() {
        if (this.selectedReportType === 1 || this.selectedReportType.toString() === '1') {
            this.clearSlaChart();
            this.createPieChart(this.reportPieDataTeam);
            this.createChartVol(this.reportPieDataTeam);
        } else {
            this.viewReportSLA = true;
            this.createBarChart(this.reportTableDat);
            this.createPieChart(this.reportPieData);
            this.createChartVol(this.reportPieData);
        }
    }

    createBarChart(slaData) {
        const element = this.chartContainer.nativeElement;
        let dwidth = element.parentElement.parentElement.offsetWidth - 60;
        let dheight = 300;
        let marginBottom = 120;
        // if(this.largegraph){
        //   dwidth = 1000;
        //   dheight = 250;
        //   marginBottom = 70;
        // }
        // else{
        //   dwidth = 500;
        //   dheight = 200;
        //   marginBottom = 40;
        // }

        const data = slaData;
        d3.select(element).select('svg').remove();
        const margin = { top: 20, right: 20, bottom: marginBottom, left: 40 },
            width = dwidth - margin.left - margin.right,
            height = dheight - margin.top - margin.bottom;

        let svg = d3.select(element).append('svg')
            .attr('width', dwidth)
            .attr('height', dheight);

        let x = d3
            .scaleBand()
            .rangeRound([0, width])
            .padding(0.1)
            .domain(data.map(d => d.analyst));

        let y = d3
            .scaleLinear()
            .rangeRound([height, 0])
            .domain([0, 100]);

        let colors = d3.scaleOrdinal(d3.schemeCategory10).domain(data.map(d => d.analyst));
        let g = svg.append('g')
            .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

        g.append('g')
            .attr('class', 'axis axis--x')
            .attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x));

        if (this.largegraph) {
            g.selectAll('text')
                .style('text-anchor', 'end')
                .attr('dx', '-.8em')
                .attr('dy', '.15em')
                .attr('transform', 'rotate(-30)');
        }

        g.append('g')
            .attr('class', 'axis axis--y')
            .call(d3.axisLeft(y).tickFormat(function (d) {
                return parseInt(d, 10) + '%';
            }))
            .append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 6)
            .attr('dy', '0.71em')
            .attr('text-anchor', 'end')
            .text('slaCompliance');

        g.selectAll('.bar')
            .data(data)
            .enter().append('rect')
            .attr('class', 'bar')
            .attr('x', d => x(d.analyst))
            .attr('y', d => y(d.slaCompliance))
            .attr('width', x.bandwidth())
            .attr('fill', function (d, i) {
                return colors(d.analyst);
            })
            .attr('height', d => height - y(d.slaCompliance));

    }

    createChartVol(slaData) {
        const element = this.barChartVolume.nativeElement;
        let dwidth = element.parentElement.parentElement.offsetWidth - 60;
        let dheight = 300;
        let marginBottom = 120;

        // if(this.largegraph){
        //   dwidth = 1000;
        //   dheight = 250;
        //   marginBottom = 70;
        // }
        // else{
        //   dwidth = 500;
        //   dheight = 200;
        //   marginBottom = 40;
        // }

        const data = slaData;
        d3.select(element).select('svg').remove();
        const margin = { top: 20, right: 20, bottom: marginBottom, left: 40 },
            width = dwidth - margin.left - margin.right,
            height = dheight - margin.top - margin.bottom;

        let svg = d3.select(element).append('svg')
            .attr('width', dwidth)
            .attr('height', dheight);

        let x = d3
            .scaleBand()
            .rangeRound([0, width])
            .padding(0.1)
            .domain(data.map(d => d.name));

        let y = d3
            .scaleLinear()
            .rangeRound([height, 0])
            .domain([0, d3.max(data, function (d) {
                return d.value;
            })]);

        let colors = d3.scaleOrdinal(d3.schemeCategory10).domain(data.map(d => d.name));
        let g = svg.append('g')
            .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

        g.append('g')
            .attr('class', 'axis axis--x')
            .attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x));

        if (this.largegraph) {
            g.selectAll('text')
                .style('text-anchor', 'end')
                .attr('dx', '-.8em')
                .attr('dy', '.15em')
                .attr('transform', 'rotate(-30)');
        }

        g.append('g')
            .attr('class', 'axis axis--y')
            .call(d3.axisLeft(y).ticks(10))
            .append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 6)
            .attr('dy', '0.71em')
            .attr('text-anchor', 'end')
            .text('value');

        g.selectAll('.bar')
            .data(data)
            .enter().append('rect')
            .attr('class', 'bar')
            .attr('x', d => x(d.name))
            .attr('y', d => y(d.value))
            .attr('width', x.bandwidth())
            .attr('fill', function (d, i) {
                return colors(d.name);
            })
            .attr('height', d => height - y(d.value));

    }

    createGroupChart(groupData) {
        let dwidth = 0;
        let dheight = 0;
        let marginBottom = 0;

        if (this.largegraph) {
            dwidth = 1000;
            dheight = 300;
            marginBottom = 120;
        } else {
            dwidth = 500;
            dheight = 200;
            marginBottom = 40;
        }
        const element = this.barChartVolume.nativeElement;
        d3.select(element).select('svg').remove();
        const margin = { top: 20, right: 20, bottom: marginBottom, left: 40 },
            width = dwidth - margin.left - margin.right,
            height = dheight - margin.top - margin.bottom;

        let x0 = d3.scaleBand().rangeRound([0, width], .5).paddingInner(0.1);
        ;
        let x1 = d3.scaleBand().padding(0.05);
        let y = d3.scaleLinear().rangeRound([height, 0]);

        let xAxis = d3.axisBottom().scale(x0).tickSize(0);
        let yAxis = d3.axisLeft().scale(y);

        const color = d3.scaleOrdinal(d3.schemeCategory10);

        let svg = d3.select(element).append('svg')
            .attr('width', dwidth)
            .attr('height', dheight)
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        const categoriesNames = groupData.map(function (d) {
            return d.type;
        });
        const rateNames = groupData[0].volume.map(function (d) {
            return d.grpName;
        });

        x0.domain(categoriesNames);
        x1.domain(rateNames).rangeRound([0, x0.bandwidth()]);
        y.domain([0, d3.max(groupData, function (key) {
            return d3.max(key.volume, function (d) {
                return d.grpValue;
            });
        })]);

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + height + ')')
            .call(xAxis);

        if (this.largegraph) {
            svg.selectAll('text')
                .style('text-anchor', 'end')
                .attr('dx', '-.8em')
                .attr('dy', '.15em')
                .attr('transform', 'rotate(-30)');
        }

        svg.append('g')
            .attr('class', 'y axis')
            .style('opacity', '0')
            .call(yAxis)
            .append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 6)
            .attr('dy', '.71em')
            .style('text-anchor', 'end')
            .style('font-weight', 'bold')
            .text('Value');

        svg.select('.y').transition().duration(500).delay(1300).style('opacity', '1');

        const slice = svg.selectAll('.slice')
            .data(groupData)
            .enter().append('g')
            .attr('class', 'g')
            .attr('transform', function (d) {
                return 'translate(' + x0(d.type) + ',0)';
            });

        slice.selectAll('rect')
            .data(function (d) {
                return d.volume;
            })
            .enter().append('rect')
            .attr('width', x1.bandwidth() - 5)
            .attr('x', function (d) {
                return x1(d.grpName);
            })
            .style('fill', function (d) {
                return color(d.grpName);
            })
            .attr('y', function (d) {
                return y(0);
            })
            .attr('height', function (d) {
                return height - y(0);
            })
            .on('mouseover', function (d) {
                d3.select(this).style('fill', d3.rgb(color(d.grpName)).darker(2));
            })
            .on('mouseout', function (d) {
                d3.select(this).style('fill', color(d.grpName));
            });


        slice.selectAll('rect')
            .transition()
            .delay(function (d) {
                return Math.random() * 1000;
            })
            .duration(1000)
            .attr('y', function (d) {
                return y(d.grpValue);
            })
            .attr('height', function (d) {
                return height - y(d.grpValue);
            });

        let legend = svg.selectAll('.legend')
            .data(groupData[0].volume.map(function (d) {
                return d.grpName;
            }).reverse())
            .enter().append('g')
            .attr('class', 'legend')
            .style('opacity', '0');

        if (this.largegraph) {
            legend.attr('transform', (d, i) => `translate(${i * 150},${height + 100})`);
        } else {
            legend.attr('transform', (d, i) => `translate(${i * 150},${height + 15})`);
        }

        legend.append('rect')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', function (d) {
                return color(d);
            });

        legend.append('text')
            .attr('x', 120)
            .attr('y', 10)
            .attr('dy', '.35em')
            .style('text-anchor', 'end')
            .text(function (d) {
                return d;
            });

        legend.transition().duration(500).delay(function (d, i) {
            return 1300 + 100 * i;
        }).style('opacity', '1');
    }

    createPieChart(data) {
        const element = this.pieChartVolume.nativeElement;
        d3.select(element).select('svg').remove();
        d3.select(element).select('div').remove();

        let text = '';
        const width = 250;
        const height = 200;
        const thickness = 40;
        const duration = 750;
        const padding = 10;
        const opacity = .8;
        const opacityHover = 1;
        const otherOpacityOnHover = .8;
        const tooltipMargin = 13;
        const radius = Math.min(width - padding, height - padding) / 2;
        //const color = d3.scaleOrdinal(d3.schemeCategory10);

        let tots = d3.sum(data, function (d) {
            return d.value;
        });

        data.forEach(function (d) {
            //d.percentage = d.value  / tots;
            d.percentage = Math.round((Number(d.value) / Number(tots)) * 100);
        });

        const dataNest = d3.nest()
            .key(function (d) {
                return d.name;
            })
            .entries(data);

        let color = d3.scaleOrdinal(d3.schemeCategory10);

        if (dataNest.length > 10) {
            color = d3.scaleOrdinal(d3.schemeCategory20);
        }

        let svg = d3.select(element)
            .append('svg')
            .attr('class', 'pie')
            .attr('width', width)
            .attr('height', height);

        let g = svg.append('g')
            .attr('transform', 'translate(' + (width / 2) + ',' + (height / 2) + ')');

        let arc = d3.arc()
            .innerRadius(0)
            .outerRadius(radius);

        let pie = d3.pie()
            .value(function (d) {
                return d.value;
            })
            .sort(null);

        let path = g.selectAll('path')
            .data(pie(data))
            .enter()
            .append('g')
            .append('path')
            .attr('d', arc)
            .attr('fill', (d, i) => color(i))
            .style('opacity', opacity)
            .style('stroke', 'white');
        // .on("mouseover", function(d) {
        //     d3.selectAll('path')
        //       .style("opacity", otherOpacityOnHover);
        //     d3.select(this)
        //       .style("opacity", opacityHover);

        //     let g = d3.select("svg")
        //       .style("cursor", "pointer")
        //       .append("g")
        //       .attr("class", "tooltip")
        //       .style("opacity", 0);

        //     g.append("text")
        //       .attr("class", "name-text")
        //       .text(`${d.data.name} (${d.data.value})`)
        //       .attr('text-anchor', 'middle');

        //     let text = g.select("text");
        //     let bbox = text.node().getBBox();
        //     let padding = 2;
        //     g.insert("rect", "text")
        //       .attr("x", bbox.x - padding)
        //       .attr("y", bbox.y - padding)
        //       .attr("width", bbox.width + (padding*2))
        //       .attr("height", bbox.height + (padding*2))
        //       .style("fill", "white")
        //       .style("opacity", 0.75);
        //   })
        // .on("mousemove", function(d) {
        //       let mousePosition = d3.mouse(this);
        //       let x = mousePosition[0] + width/2;
        //       let y = mousePosition[1] + height/2 - tooltipMargin;

        //       let text = d3.select('.tooltip text');
        //       let bbox = text.node().getBBox();
        //       if(x - bbox.width/2 < 0) {
        //         x = bbox.width/2;
        //       }
        //       else if(width - x - bbox.width/2 < 0) {
        //         x = width - bbox.width/2;
        //       }
        //       if(y - bbox.height/2 < 0) {
        //         y = bbox.height + tooltipMargin * 2;
        //       }
        //       else if(height - y - bbox.height/2 < 0) {
        //         y = height - bbox.height/2;
        //       }

        //       d3.select('.tooltip')
        //         .style("opacity", 1)
        //         .attr('transform',`translate(${x}, ${y})`);
        //   })
        // .on("mouseout", function(d) {
        //     d3.select("svg")
        //       .style("cursor", "none")
        //       .select(".tooltip").remove();
        //   d3.selectAll('path')
        //       .style("opacity", opacity);
        //   })
        // .on("touchstart", function(d) {
        //     d3.select("svg")
        //       .style("cursor", "none");
        // })
        // .each(function(d, i) { this._current = i; });

        var arcGenerator = d3.arc()
            .innerRadius(0)
            .outerRadius(radius);

        let textPer = g.selectAll('.pie')
            .data(pie(data))
            .enter()
            .append('g')
            .append('text')
            .text(function (d) {
                return d.data.percentage + '%';
            })
            .attr('transform', function (d) {
                return 'translate(' + arcGenerator.centroid(d) + ')';
            })
            .style('text-anchor', 'middle')
            .style('font-size', '12px')
            .style('fill', '#000000')
            .style('font-weight', '500');

        let legend = d3.select(element).append('div')
            .attr('class', 'legend')
            .style('margin-top', '30px');

        let keys = legend.selectAll('.key')
            .data(data)
            .enter().append('div')
            .attr('class', 'key')
            .style('display', 'flex')
            .style('align-items', 'center')
            .style('margin-right', '20px');

        keys.append('div')
            .attr('class', 'symbol')
            .style('height', '10px')
            .style('width', '10px')
            .style('margin', '5px 5px')
            .style('background-color', (d, i) => color(i));

        keys.append('div')
            .attr('class', 'name')
            .text(d => `${d.name} (${d.value})`);

        keys.exit().remove();
    }

    onResize(e) {
        this.generateReportGraph();
    }

    exportAsPDF() {
        this.dataLoaded = false;
        const elementReport = this.reportBody.nativeElement;
        let reportTitle = 'Productivity - ';
        let fileName = 'Productivity ' + this.reportTypeTitle + ' wise.pdf';
        if (this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === '6') {
            const tilldate = this.messageService.ticketConverter(this.tillDate, 1);
            reportTitle = reportTitle + ' till ' + tilldate;
        } else if (this.selectedReportFilter === 7 || this.selectedReportFilter.toString() === '7') {
            const fdate = this.messageService.ticketConverter(this.fromDate, 1);
            const tdate = this.messageService.ticketConverter(this.toDate, 1);
            reportTitle = reportTitle + ' ' + fdate + ' to ' + tdate;
        } else {
            reportTitle = reportTitle + ' ' + this.reportFilterTitle;
        }

        html2canvas(elementReport, {
            scale: 2
        }).then(canvas => {
            const imgWidth = 208;
            const pageHeight = 295;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            const heightLeft = imgHeight;
            const contentDataURL = canvas.toDataURL('image/png');
            let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
            pdf.setFont('helvetica');
            pdf.setFontType('bold');
            pdf.setFontSize(9);
            pdf.text(reportTitle, 10, 10);
            pdf.addImage(contentDataURL, 'PNG', 0, 20, imgWidth, imgHeight - 20);
            pdf.save(fileName); // Generated PDF
            this.dataLoaded = true;
        });
    }


}
